import styled from 'styled-components';

export const StyledLineBreakDivider = styled.div`
  width: 100%;
  visibility: hidden;
  transition: all 300ms ease;
`;

const expressionToken = `
  font-family: var(--cl-font-family-mono);
  font-size: var(--cl-font-size-2);
  white-space: pre;
`;

export const StyledFunctionComma = styled.span`
  ${expressionToken}
  color: var(--cl-text-default);
`;

// matches the box a dropdown draws a parenthesis in, so this one lines up with the closing one
export const StyledFunctionParenthesis = styled.span`
  ${expressionToken}
  display: inline-flex;
  /* sit close to the function name: drop our own left padding, leaving the name's small right gap */
  padding: 0 3px 0 0;
  border-top: 2px solid transparent;
  color: var(--cl-text-default);
  font-weight: bold;
`;
